import React, { useEffect, useState } from 'react';
import { db } from '../../firebaseConfig';
import {
  collection,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
  query,
  where,
} from 'firebase/firestore';
import { useTranslation } from 'react-i18next';
import './ManageCustomers.css'; // Reuse existing styles
import BackToClinicDashboard from '../BackToClinicDashboard';
import { useParams } from 'react-router-dom';

const ManageCustomers = () => {
  const { t } = useTranslation();
  const [customers, setCustomers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    address: '',
    phone: '',
  });
  const { token } = useParams();

  const fetchCustomers = async () => {
    const q = query(collection(db, 'customers'), where('type', '==', 'clinic'));
    const snapshot = await getDocs(q);
    const result = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setCustomers(result);
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const handleEdit = (customer) => {
    setEditingId(customer.id);
    setFormData({
      name: customer.name || '',
      email: customer.email || '',
      address: customer.address || '',
      phone: customer.phone || '',
    });
  };

  const handleDelete = async (id) => {
    await deleteDoc(doc(db, 'customers', id));
    fetchCustomers();
  };

  const handleUpdate = async () => {
    await updateDoc(doc(db, 'customers', editingId), formData);
    setEditingId(null);
    setFormData({ name: '', email: '', address: '', phone: '' });
    fetchCustomers();
  };

  const exportToCSV = () => {
    const headers = ['Name', 'Email', 'Address', 'Phone', 'Token', 'Clinic Name'];
    const rows = customers.map(c => [
      c.name,
      c.email,
      c.address,
      c.phone,
      c.token,
      c.clinic_name,
    ]);
    const csv = [headers, ...rows].map(r => r.map(cell => `"${cell}"`).join(',')).join('\n');

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'clinic_customers.csv';
    link.click();
  };

  return (
    <div className="manage-clinics-container">
      <h2 className="manage-clinics-title">{t('manageCustomers.title')}</h2>
      <button onClick={exportToCSV} className="clinic-action-btn export-btn">
        {t('manageCustomers.exportCsv')}
      </button>
      <BackToClinicDashboard token={token} />

      {editingId && (
        <div className="manage-clinics-form">
          <input value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} placeholder={t('manageCustomers.name')} />
          <input value={formData.email} onChange={e => setFormData({ ...formData, email: e.target.value })} placeholder={t('manageCustomers.email')} />
          <input value={formData.address} onChange={e => setFormData({ ...formData, address: e.target.value })} placeholder={t('manageCustomers.address')} />
          <input value={formData.phone} onChange={e => setFormData({ ...formData, phone: e.target.value })} placeholder={t('manageCustomers.phone')} />
          <button onClick={handleUpdate} className="manage-clinics-submit-btn">{t('manageCustomers.update')}</button>
        </div>
      )}

      <div className="clinic-list">
        {customers.map(c => (
          <div key={c.id} className="clinic-card">
            <div className="clinic-card-info">
              <p><strong>{c.name}</strong> - {c.email}</p>
              <p>{c.address} | {c.phone}</p>
              <p>{t('manageCustomers.clinic')}: <strong>{c.clinic_name}</strong></p>
              <p>
                Token: <code>{c.token}</code>
                <button
                className="copy-link-btn"
                  onClick={() => {
                    navigator.clipboard.writeText(`${window.location.origin}/customer-clinic/${c.token}`);
                    alert(t('manageCustomers.linkCopied'));
                  }}
                >{t('manageCustomers.copy_link')}</button>
              </p>
            </div>
            <div className="clinic-card-actions">
              <button onClick={() => handleEdit(c)} className="clinic-action-btn">{t('manageCustomers.edit')}</button>
              <button onClick={() => handleDelete(c.id)} className="clinic-action-btn delete-btn">{t('manageCustomers.delete')}</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ManageCustomers;